<template>
  <footer>
    <ul>
      <li>전화문의 : <a href="tel:0903745077">0903745077</a></li>
      <li>
        카카오톡 문의 :
        <a href="http://qr.kakao.com/talk/IPaaewyCbKbsb8gtzCR_KPP_nyQ-">
          nkricecake
        </a>
      </li>
      <li>
        인스타그램 :
        <a href="https://www.instagram.com/rice.cake.hcm/">@rice.cake.hcm</a>
      </li>
    </ul>
    <address>49 Hậu Giang, Phường 4, Tân Bình, HCMC</address>
  </footer>
</template>

<script>
export default {
  name: "Footer",
};
</script>

<style lang="scss" scoped>
@import "@/assets/utils/scss/fluid-typo.scss";
footer {
  text-align: center;
  padding: 20px;
  background: #f2ecec;
  color: #666261;
  @include fluid-type(320px, 1600px, 12px, 24px);

  ul {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    list-style-type: none;
    padding: 0;
    margin: 0;
    li {
      display: flex;
      align-items: center;
      strong {
        color: #2d2a29;
        margin-left: 5px;
      }
      &::after {
        content: "";
        display: block;
        margin: 0 10px;
        width: 1px;
        height: 80%;
        background: #666261;
      }
      &:last-of-type {
        &::after {
          display: none;
        }
      }
    }
  }
  address {
    font-style: normal;
    margin-top: 5px;
  }
}
</style>
